import { action } from 'typesafe-actions';
import localStorage from 'local-storage';
import history from 'app/routes/history';
import { IPagination } from 'app/types/common';
import { ForfeitsActionTypes as types } from './types';

/* ********************************* APP ACTIONS ********************************* */

export const createForfeit = (data): any => action(types.CREATE_FORFEIT_REQUESTED, data);

export const updateForfeit = (data): any => action(types.UPDATE_FORFEIT_REQUESTED, data);

export const deleteForfeit = (forfeitId): any => action(types.UPDATE_FORFEIT_REQUESTED, forfeitId);

export const getForfeit = (forfeitId): any => action(types.GET_FORFEIT_REQUESTED, forfeitId);

export const getAllForfeits = (
  pagination: IPagination = undefined,
  compile = true,
): any => action(types.GET_ALL_FORFEITS_REQUESTED, { pagination, compile });

export const selectForfeit = (forfeitId): any => action(types.SELECT_FORFEIT_REQUESTED, {
  currentForfeitId: forfeitId,
});

/* ********************************* SAGA ACTIONS ********************************* */
export const sagaActions = {
  createForfeitPending: (payload): any => action(types.CREATE_FORFEIT_PENDING, payload),
  createForfeitSuccess: (response): any => {
    const currentForfeit = response.entities.walkovers[response.result];
    if (currentForfeit.fee === 0 && currentForfeit.covid) {
      history.push(`/forfeit/confirm/covid/${currentForfeit.id}`);
    } else {
      history.push(`/payment/forfeit/${currentForfeit.id}/review`);
    }
    return action(types.CREATE_FORFEIT_SUCCESS, {
      forfeitsById: response.entities.walkovers,
      currentForfeitId: response.result,
    });
  },
  updateForfeitPending: (payload): any => action(types.UPDATE_FORFEIT_PENDING, payload),
  updateForfeitSuccess: (response): any => action(types.UPDATE_FORFEIT_SUCCESS, {
    forfeitsById: response.entities.forfeits,
    currentForfeitId: response.result,
  }),
  updateForfeitFailed: (error): any => action(types.UPDATE_FORFEIT_FAIL, { backendErrors: error }),
  deleteForfeitPending: (): any => action(types.UPDATE_FORFEIT_PENDING, {}),
  deleteForfeitSuccess: (response, userId): any => {
    localStorage.set(userId, { currentForfeitId: null });
    history.push('/forfeits');

    return action(types.DELETE_FORFEIT_SUCCESS, {
      currentForfeitId: response,
    });
  },
  getForfeitPending: (): any => action(types.GET_FORFEIT_PENDING, {}),
  getForfeitSuccess: (response): any => action(types.GET_FORFEIT_SUCCESS, {
    forfeitsById: response.entities.walkovers,
    currentForfeitId: response.result,
  }),
  getForfeitFailed: (error): any => action(types.GET_FORFEIT_FAIL, { backendErrors: error }),
  deleteForfeitFailed: (error): any => action(types.UPDATE_FORFEIT_FAIL, { backendErrors: error }),
  getAllForfeitsPending: (pagination): any => action(types.GET_ALL_FORFEITS_PENDING, { pagination }),
  getAllForfeitsSuccess: (response, meta): any => action(types.GET_ALL_FORFEITS_SUCCESS, {
    forfeitsById: response.entities.forfeits,
    forfeitIds: response.result,
    meta,
  }),
  getAllForfeitsFailed: (error): any => action(types.GET_ALL_FORFEITS_FAIL, { backendErrors: error }),
  createForfeitFailed: (error): any => action(types.CREATE_FORFEIT_FAIL, { backendErrors: error }),
};

export default null;
